import secondaryComponents from "../../../../../components/secondaryComponents";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import { motion } from "framer-motion";

const PrintCustomaizationPage = () => {
  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Inventory - Printer Settings"
      description={"Manage receipt customization"}
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 0.3 } }}
          className={`${globalStyles.pageColumnGaps}`}
        >
          <secondaryComponents.ReceiptCustomization />
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};

export default PrintCustomaizationPage;
